<script>
    import FancyButton from './FancyButton.svelte';
</script>

<FancyButton label="Play as a Warehouse Worker" image={"/worker.svg"}/>